module.exports = __webpack_public_path__ + "static/media/tire.ca57433d.png";